import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import SvgIcon from '../../atoms/SvgIcon/SvgIcon';
import MenuSearch from './MenuSearch';

var onSubmenuKeyPress = function onSubmenuKeyPress(e, onToggleSubmenu) {
  var key = e.which || e.keyCode;

  if (key === 13) {
    // 13 = enter
    onToggleSubmenu(e);
  }
};

var ItemWithSubmenu = function ItemWithSubmenu(_ref) {
  var onToggleSubmenu = _ref.onToggleSubmenu,
      isOpen = _ref.isOpen,
      link = _ref.link,
      LinkTemplate = _ref.LinkTemplate;
  return React.createElement("div", {
    tabIndex: "0",
    className: "menu__item link menu__submenu",
    onKeyPress: function onKeyPress(e) {
      return onSubmenuKeyPress(e, onToggleSubmenu);
    }
  }, React.createElement("span", {
    className: "menu__submenu-link",
    onClick: onToggleSubmenu
  }, link.text, React.createElement(SvgIcon, {
    iconName: "ico_dropArrow",
    color: "purple",
    className: classnames('icon-link__icon menu__submenu-icon', {
      'menu__submenu-icon--open': isOpen
    })
  })), React.createElement("div", {
    className: classnames('menu__submenu-container', {
      'menu__submenu-container--open': isOpen
    })
  }, link.subLinks.map(function (sublink, index) {
    return React.createElement(LinkTemplate, {
      key: sublink.tex,
      className: "menu__subitem link",
      url: sublink.url
    }, React.createElement("span", {
      className: "link__content"
    }, sublink.text));
  })));
};

var MenuLinkItem = function MenuLinkItem(_ref2) {
  var link = _ref2.link,
      LinkTemplate = _ref2.LinkTemplate,
      onToggleSubmenu = _ref2.onToggleSubmenu,
      isSubmenuOpen = _ref2.isSubmenuOpen;
  return React.createElement("li", null, link.url && React.createElement(LinkTemplate, {
    className: "menu__item link",
    url: link.url
  }, React.createElement("span", {
    className: "link__content"
  }, link.text)), !link.url && React.createElement(ItemWithSubmenu, {
    link: link,
    onToggleSubmenu: onToggleSubmenu,
    isOpen: isSubmenuOpen,
    LinkTemplate: LinkTemplate
  }));
};

var _ref4 = React.createElement(SvgIcon, {
  className: "menu__login-button-icon",
  iconName: "ico_login",
  color: "none"
});

var LoginButton = function LoginButton(_ref3) {
  var loginUrl = _ref3.loginUrl;
  return React.createElement("a", {
    href: loginUrl,
    className: "menu__login-button button button--small"
  }, _ref4, "logg inn");
};

var _ref6 = React.createElement(SvgIcon, {
  className: "menu__mypage-button-icon",
  iconName: "ico_login",
  color: "none"
});

var MyPageButton = function MyPageButton(_ref5) {
  var myPageUrl = _ref5.myPageUrl;
  return React.createElement("a", {
    href: myPageUrl,
    className: "menu__mypage-button button button--small"
  }, _ref6, "min side");
};

var _ref8 = React.createElement(SvgIcon, {
  className: "menu__mobile-button-icon",
  iconName: "ico_menu_mobile",
  color: "black"
});

var _ref9 = React.createElement("span", {
  className: "menu__mobile-button-text"
}, "Meny");

var MobileMenuButton = function MobileMenuButton(_ref7) {
  var onMenuToggle = _ref7.onMenuToggle;
  return React.createElement("button", {
    className: "menu__mobile-button",
    onClick: onMenuToggle
  }, _ref8, _ref9);
};

var MenuContent = function MenuContent(_ref10) {
  var menuLink = _ref10.menuLink,
      openedSubmenuIndex = _ref10.openedSubmenuIndex,
      _onToggleSubmenu = _ref10.onToggleSubmenu,
      logo = _ref10.logo,
      LinkTemplate = _ref10.LinkTemplate,
      onMobileMenuToggle = _ref10.onMobileMenuToggle,
      onSearchSubmit = _ref10.onSearchSubmit,
      isLoggedIn = _ref10.isLoggedIn,
      loginUrl = _ref10.loginUrl,
      myPageUrl = _ref10.myPageUrl;
  return React.createElement("div", {
    className: "menu__content"
  }, React.createElement(MenuLogo, {
    LinkTemplate: LinkTemplate,
    logo: logo
  }), React.createElement("ul", {
    id: "".concat(menuLink.heading.text, "-panel"),
    className: "menu__content-panel"
  }, menuLink.links.map(function (link, index) {
    return React.createElement(MenuLinkItem, {
      LinkTemplate: LinkTemplate,
      isSubmenuOpen: openedSubmenuIndex === index,
      onToggleSubmenu: function onToggleSubmenu(event) {
        return _onToggleSubmenu(index, event);
      },
      key: link.text,
      link: link
    });
  })), React.createElement("div", {
    className: "menu__content-right"
  }, onSearchSubmit && React.createElement(MenuSearch, {
    onSubmit: onSearchSubmit
  }), loginUrl && !isLoggedIn && React.createElement(LoginButton, {
    loginUrl: loginUrl
  }), myPageUrl && isLoggedIn && React.createElement(MyPageButton, {
    myPageUrl: myPageUrl
  }), React.createElement(MobileMenuButton, {
    onMenuToggle: onMobileMenuToggle
  })));
};

var MenuLogo = function MenuLogo(_ref11) {
  var _ref11$logo = _ref11.logo,
      url = _ref11$logo.url,
      image = _ref11$logo.image,
      imageInverted = _ref11$logo.imageInverted,
      title = _ref11$logo.title,
      LinkTemplate = _ref11.LinkTemplate;
  return React.createElement(LinkTemplate, {
    url: url,
    className: "menu__logo-container"
  }, React.createElement("img", {
    className: "menu__logo",
    src: image,
    alt: title
  }), React.createElement("img", {
    className: "menu__logo--inverted",
    src: imageInverted,
    alt: title
  }));
};

MenuContent.propTypes = process.env.NODE_ENV !== "production" ? {
  menuLink: PropTypes.shape({
    links: PropTypes.array,
    heading: PropTypes.shape({
      text: PropTypes.string
    })
  }),
  logo: PropTypes.shape({
    url: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string
  }),
  openedSubmenuIndex: PropTypes.number,
  onToggleSubmenu: PropTypes.func
} : {};
export default MenuContent;